export const WRAPPER_CLASSES = "flex w-full flex-col text-left"
export const WRAPPER_SM_CLASSES = "gap-1"
export const WRAPPER_MD_CLASSES = "gap-1.5"
